(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$rootScopeProvider'];

    /**
     * Created by vimpans on 2019/7/11
     */

    function stateConfig($stateProvider) {
        $stateProvider
            .state('activities', {
                parent: 'module',
                url: '/activities',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/activity/activities.html',
                        controller: 'ActivitiesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('activity', {
                parent: 'module',
                url: '/activity?:id',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/activity/activity.html',
                        controller: 'ActivityController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
